import { Component, OnInit } from "@angular/core";
import { Company } from "src/app/ui/models/domains/pbm/companies/company";
import { TopTenProductsIndicatorData } from "src/app/ui/models/domains/pbm/indicators/top-ten-indicator-data";
import { TopTenTherapeuticClassIndicatorDataStrategy } from "src/app/ui/pages/home/indicator-data-strategies";
import { IndicatorMediator } from "src/app/ui/services/pbm/indicator-mediator";
import { IndicatorService } from "src/app/ui/services/pbm/indicator.service";

@Component({
  selector: "top-ten-therapeutic-class",
  templateUrl: "./top-ten-therapeutic-class.component.html",
  styleUrls: ["./top-ten-therapeutic-class.component.scss"],
})
export class TopTenTherapeuticClassComponent implements OnInit {
  public topTenTherapeuticClass: TopTenProductsIndicatorData;
  public isLoading: boolean = true;

  constructor(private indicatorService: IndicatorService, private indicatorMediator: IndicatorMediator) {}

  async ngOnInit() {
    this.topTenTherapeuticClass = (await this.indicatorMediator.getIndicatorData(
      new TopTenTherapeuticClassIndicatorDataStrategy(),
    )) as TopTenProductsIndicatorData;
    this.isLoading = false;
  }

  public async onFilterData(company: Company) {
    this.isLoading = true;
    if (company) this.topTenTherapeuticClass = await this.indicatorService.getTopTenTherapeuticClass([company.getFiscalNumber()]);
    else this.topTenTherapeuticClass = await this.indicatorService.getTopTenTherapeuticClass();
    this.isLoading = false;
  }

  public getTotal(): string {
    return this.topTenTherapeuticClass && this.topTenTherapeuticClass.getTotal();
  }

  public getTopTenTherapeuticClassList() {
    return this.topTenTherapeuticClass && this.topTenTherapeuticClass.getItems();
  }

  public hasTopTenTherapeuticClassData(): boolean {
    return !!this.topTenTherapeuticClass && !!this.topTenTherapeuticClass.getItems().length;
  }

  public trackByFn = (index: number, item: any) => item.id;
}
